import * as PIXI from 'pixi.js';
// const { PIXI } = window.flatworld_libraries;

const constants = {
  ZERO_COORDINATES: new PIXI.Point(0,0),
  VERSION: '0.6.5',
  DEFAULT_SCALE_MODE: 0
};

/*---------------------
--------- API ---------
----------------------*/
export default constants;



/** WEBPACK FOOTER **
 ** ./src/core/constants.js
 **/